module.exports = __webpack_public_path__ + "static/media/sankt-petersburg-placuta.ec34bf54.png";